(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-merge-item', {
            parent: 'entity',
            url: '/handbook-merge-item?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-items.html',
                    controller: 'HandbookMergeItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeItem');
                    $translatePartialLoader.addPart('handbookMergeItemChangeType');
                    $translatePartialLoader.addPart('handbookMergeItemChangeIn');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-merge-item-detail', {
            parent: 'handbook-merge-item',
            url: '/handbook-merge-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-detail.html',
                    controller: 'HandbookMergeItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeItem');
                    $translatePartialLoader.addPart('handbookMergeItemChangeType');
                    $translatePartialLoader.addPart('handbookMergeItemChangeIn');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookMergeItem', function($stateParams, HandbookMergeItem) {
                    return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-merge-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-merge-item-detail.edit', {
            parent: 'handbook-merge-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-dialog.html',
                    controller: 'HandbookMergeItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeItem', function(HandbookMergeItem) {
                            return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-item.new', {
            parent: 'handbook-merge-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-dialog.html',
                    controller: 'HandbookMergeItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nodeUUID: null,
                                changeType: null,
                                changeIn: null,
                                merged: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-item', null, { reload: 'handbook-merge-item' });
                }, function() {
                    $state.go('handbook-merge-item');
                });
            }]
        })
        .state('handbook-merge-item.edit', {
            parent: 'handbook-merge-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-dialog.html',
                    controller: 'HandbookMergeItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeItem', function(HandbookMergeItem) {
                            return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-item', null, { reload: 'handbook-merge-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-item.delete', {
            parent: 'handbook-merge-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-item/handbook-merge-item-delete-dialog.html',
                    controller: 'HandbookMergeItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookMergeItem', function(HandbookMergeItem) {
                            return HandbookMergeItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-item', null, { reload: 'handbook-merge-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
